<app-page-bar></app-page-bar>

<app-page>
  <h2>{{title}}</h2>

  <section>
    <div class="table-container mat-elevation-z8">
      <mat-table #table [dataSource]="dataSource">

        <ng-container matColumnDef="created_at">
          <mat-header-cell *matHeaderCellDef>Created</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.created_at | date:'short'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="invoice_id">
          <mat-header-cell *matHeaderCellDef>Invoice</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.invoice_id}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="task_type">
          <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.task_type}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.status}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="updated_at">
          <mat-header-cell *matHeaderCellDef>Updated</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.updated_at | date:'short'}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns;"
                 matRipple
                 [routerLink]="['/invoices', row.invoice_id]"
                 [class.status-failed]="row.status !== 'COMPLETED' && row.status !== 'PENDING'">
        </mat-row>

      </mat-table>
    </div>
  </section>
</app-page>
